'use strict';

angular.module('user')
    .component('changePasswordForm', {
        templateUrl: 'js/modules/user/components/change-password-form/template.html',
        controller: 'ChangePasswordFormController',
        bindings: {
            recoveryData: '<', // {userId, recoverHash}
            onSubmit: '&',
        },
    });
